module["exports"] = [
  "#{city_name}"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/sk/address/city.js
// module id = 1546
// module chunks = 0